import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef} from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MapAssetContainer from "site-apps/assets/MapAssetContainer";
import {SwalAlertClass} from "core/swalClass";
import {addOrUpdateList} from "core/utils/arrays";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import axiApi from "ApiCaller";
import TabContainers from "./TabContainers";
import ModalSelectAssetMultiple from "site-apps/assets/components/ModalSelectAssetMultiple";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import Button from "react-bootstrap/Button";
import MapManagerModal from "components/maps/MapManagerModal";

const FormIsland = ({setShowForm, showForm, item, setItemsShow, items, itemsShow, fetchIslands, params}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tc} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [formData, setFormData] = useState({...item});
    const [showMap, setShowMap] = useState(false);
    const [showModalAssets, setShowModalAssets] = useState(false);
    const [assets, setAssets] = useState([...item.actives]);
    const actives = useRef([]);
    const [filtersModalAssets, setFiltersModalAssets] = useState({
        coords_lat: "",
        coords_lng: "",
    });
    const [isProcessing, setIsProcessing] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [polyline, setPolyline] = useState([]);

    useEffect(() => {
        const handlePositionSelected = (e) => {
            const {lat, lng} = e.detail;
            setFormData((prev) => ({
                ...prev,
                lat: lat.toFixed(6),
                lng: lng.toFixed(6),
            }));
        };

        subscribeEvent("mapmodal:position:selected", handlePositionSelected);

        return () => {
            unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
        };
    }, []);

    useEffect(() => {
        setFormData({...item});
        setAssets([...item.actives]);
        actives.current = [...item.actives];
        if (item.lat && item.lng) {
            setFiltersModalAssets({
                coords_lat: item.lat.toString(),
                coords_lng: item.lng.toString(),
            });
        }

        return () => {
            unsubscribeEvent("assets:modal:selector", onSelectAssets);
        };
    }, [item, showForm]);

    useEffect(() => {
        if (formData.lat && formData.lng && showForm) {
            if (item?.zone_data?.polylines) {
                setPolyline(item.zone_data.polylines);
            }
            setShowMap(true);
        }
    }, [formData.lat, formData.lng, showForm]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "zone_id") {
            const zone = params.current.zones.find((z) => z.id === parseInt(value));
            if (zone) {
                setPolyline(zone.polylines);
            }
        }
    };

    const handleModalMap = () => {
        setShowMapModal(true);
    };

    const onClickSelectAssets = () => {
        setFiltersModalAssets({
            coords_lat: formData.lat.toString() || "",
            coords_lng: formData.lng.toString() || "",
        });
        setShowModalAssets(true);
        subscribeEvent("assets:modal:selector", onSelectAssets);
    };

    function onSelectAssets(e) {
        setAssets([...e.detail.assets]);
        actives.current = [...e.detail.assets];
        unsubscribeEvent("assets:modal:selector", onSelectAssets);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (!formData.name || formData.name.trim() === "") {
            Alert.warning(_Tc("field.must"), _Tc("field.must.island.name"));
            return;
        }
        setIsProcessing(true);

        let assetsIds = [];
        actives.current.forEach((_asset) => {
            assetsIds.push(_asset.id);
        });

        let form = {...formData};
        form.assets = assetsIds;

        axiApi
            .post("/api/distribution/island/", form)
            .then((resp) => {
                if (resp.data.status) {
                    Alert.success(_Tf("labels.success"), _Tf("success.title"));
                    fetchIslands();
                    setShowMap(false);
                    setShowForm(false);
                    items.current.clearChosen();
                } else {
                    Alert.warning(_Tc("notify.admin"), _Tc("alert.service.error"));
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error(_Tf("errors.title"), _Tf("errors.server-error"));
            })
            .finally(() => {
                setIsProcessing(false);
            });
    };

    return (
        <div className={`${showForm ? "col-md-4 col-12" : "col-md-4 col-12 d-none"}`}>
            {showModalAssets ? (
                <ModalSelectAssetMultiple
                    show={showModalAssets}
                    setShow={setShowModalAssets}
                    filtering={filtersModalAssets}
                    chosenIn={assets}
                    multiple={true}
                    subtitle={"Isla: " + item.name}
                />
            ) : (
                <></>
            )}
            <div className="col preview-row" style={{width: "300px", maxWidth: "300px"}}>
                <div className="row">
                    <div className="col-12 p-0">
                        <div
                            className="preview-card"
                            style={{
                                width: "25%",
                                height: "calc(100vh - 160px)",
                                overflowY: "auto",
                            }}>
                            <Form onSubmit={onSubmit}>
                                <div className="preview-header">
                                    <div className="preview-icon">
                                        <FontAwesomeIcon icon="boxes-stacked" />
                                    </div>
                                    <div className="preview-title ms-3">
                                        {_Tf("labels.island")}
                                        <div>{item.name}</div>
                                    </div>
                                </div>
                                <Tabs defaultActiveKey="data" id="fromislands" className="mb-3">
                                    <Tab eventKey="data" title={_Tc("tab.data")}>
                                        <div className="preview-item">
                                            <label>{_Tf("common.name")}</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="preview-item">
                                            <label>{_Tf("common.description")}</label>
                                            <textarea
                                                rows="5"
                                                className="form-control mb-2"
                                                id="description"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="preview-item">
                                            <label>{_Tf("common.full-address")}</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                id="full_address"
                                                name="full_address"
                                                maxLength={255}
                                                value={formData.full_address || ""}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="preview-item">
                                            <label htmlFor="zone_id" className="form-label">
                                                {_Tc("zone")}
                                            </label>
                                            <Form.Select
                                                className="mb-2"
                                                id="zone_id"
                                                name="zone_id"
                                                value={formData.zone_id}
                                                onChange={handleChange}>
                                                <option value="">Seleccionar</option>
                                                {params.current.zones.map((zone) => (
                                                    <option key={zone.id} value={zone.id}>
                                                        {zone.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </div>

                                        <div className="col-12 card pb-3 mt-3">
                                            <div className="row">
                                                <div className="col-1"></div>
                                                <div className="mt-2 col-4">
                                                    <label htmlFor="lat" className="form-label">
                                                        {_Tf("common.latitude")}
                                                    </label>
                                                    <input
                                                        type="number"
                                                        max="90"
                                                        min="-90"
                                                        className="form-control"
                                                        id="lat"
                                                        name="lat"
                                                        step="any"
                                                        value={formData.lat}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="mt-2 col-4">
                                                    <label htmlFor="lng" className="form-label">
                                                        {_Tf("common.longitude")}
                                                    </label>
                                                    <input
                                                        type="number"
                                                        max="90"
                                                        min="-90"
                                                        step="any"
                                                        className="form-control"
                                                        id="lng"
                                                        name="lng"
                                                        value={formData.lng}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-1"></div>
                                                <div className="mt-3 pt-3 col-2">
                                                    <Button
                                                        title="Editar ubicación"
                                                        variant="btn btn-outline-primary"
                                                        type="button"
                                                        onClick={handleModalMap}>
                                                        <FontAwesomeIcon icon="fa-map-location-dot" />
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>

                                        {showMap ? (
                                            <div className="mt-3 preview-item">
                                                <MapAssetContainer position={[formData.lat, formData.lng]} polyline={polyline} />
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </Tab>

                                    <Tab eventKey="containers" title={_Tc("tab.containers")}>
                                        <TabContainers
                                            onClickSelectAssets={onClickSelectAssets}
                                            setShowModalAssets={setShowModalAssets}
                                            assets={assets}
                                            setAssets={setAssets}
                                        />
                                    </Tab>
                                </Tabs>
                                <div className="preview-item mt-5">
                                    <div className="preview-input">
                                        <div className="d-flex justify-content-end mb-3">
                                            <button type="button" className="btn btn-primary" onClick={(e) => setShowForm(false)}>
                                                {_Tc("button.cancel")}
                                            </button>

                                            <FormButton
                                                type="submit"
                                                // onClick={onSubmit}
                                                className="btn btn-primary ms-2"
                                                isProcessing={isProcessing}>
                                                {_Tc("button.save")}
                                            </FormButton>
                                        </div>
                                    </div>
                                </div>
                                <MapManagerModal
                                    show={showMapModal}
                                    setShow={setShowMapModal}
                                    title={"Island"}
                                    initialLat={formData.lat}
                                    initialLng={formData.lng}
                                />
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormIsland;
